import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=8a230bc0"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a230bc0')) {
      api.createRecord('8a230bc0', component.options)
    } else {
      api.reload('8a230bc0', component.options)
    }
    module.hot.accept("./AdminPanel.vue?vue&type=template&id=8a230bc0", function () {
      api.rerender('8a230bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminPanel.vue"
export default component.exports